import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	standardTrialBegins: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.timeline-section.standard-trial-begins',
		defaultMessage: '{trialStartDate}: Standard trial begins',
		description:
			'The starting date of the Standard trial. The user will have access to Standard features until the trial ends.',
	},
	standardTrialBeginsWithoutDate: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.timeline-section.standard-trial-begins-without-date',
		defaultMessage: 'Standard trial begins',
		description:
			'The starting date of the Standard trial. The user will have access to Standard features until the trial ends.',
	},
	standardTrialBeginsDescription: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.timeline-section.standard-trial-begins-description',
		defaultMessage: "Explore Standard's powerful features",
		description:
			'The starting date of the Standard trial. The user will have access to Standard features until the trial ends.',
	},
	standardTrialEnds: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.timeline-section.standard-trial-ends',
		defaultMessage: '{trialEndDate}: Trial ends',
		description:
			'The end date of the Standard trial. The user will need to add payment details before this date to keep Standard features.',
	},
	standardTrialEndsWithoutDate: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.timeline-section.standard-trial-ends-without-date',
		defaultMessage: 'Trial ends',
		description:
			'The end date of the Standard trial. The user will need to add payment details before this date to keep Standard features.',
	},
	standardTrialEndsDescription: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.timeline-section.standard-trial-ends-description',
		defaultMessage: 'Add payment details to keep Standard features, or downgrade to Free.',
		description:
			'The end date of the Standard trial. The user will need to add payment details before this date to keep Standard features.',
	},
});
